document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.renovo-gallery').forEach(gallery => {
    const track = gallery.querySelector('.renovo-gallery__track');
    const slides = [...gallery.querySelectorAll('.renovo-gallery__slide')];
    const prev = gallery.querySelector('.renovo-gallery__prev');
    const next = gallery.querySelector('.renovo-gallery__next');
    const current = gallery.querySelector('.renovo-gallery__current');

    if (slides.length < 2) return;

    const getIndex = () => {
      return Math.round(track.scrollLeft / track.clientWidth);
    };

    const goTo = index => {
      // Loop forwards: last slide → first slide
      if (index >= slides.length) {
        index = 0;
      }

      // Loop backwards: first slide → last slide
      if (index < 0) {
        index = slides.length - 1;
      }

      track.scrollTo({
        left: index * track.clientWidth,
        behavior: 'smooth'
      });
    };

    prev.addEventListener('click', () => {
      goTo(getIndex() - 1);
    });

    next.addEventListener('click', () => {
      goTo(getIndex() + 1);
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => {
        current.textContent = getIndex() + 1;
      });
    });
  });
});